export default __webpack_public_path__ + "static/map-4dab10037f33d47070a69b09ceeb60c3.jpg";